import Carousel from "react-bootstrap/Carousel";
import { Button, Col, Container, Image, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import ConstConfig from "../../utility/configs/constConfig";
import { trackButtonClick } from "../../utility/services/analyticsService";

import Loader from "../images/newimg/home_banner_loader.gif";

const HomeSlider = (props) => {
  const { isUserDetails, set_login_role, banner_details } = props.data;
  const isBannerDetails = banner_details.length > 0;
  return (
    <>
      <Carousel interval={6000} slide={true} pause={false}>
        {isBannerDetails ? (
          banner_details.map((item) => (
            <Carousel.Item key={item._id.toString()}>
              <section
                className="bgHome black_over_lay"
                style={{
                  backgroundImage: `url(
                    ${ConstConfig.IMAGE_URL}/${item.image}
                  )`,
                }}
              >
                <Container>
                  <Row>
                    <Col lg={6}>
                      <div className="contentBox">
                        <h1 data-aos="fade-up" data-aos-duration="1000">
                          {item.title}
                        </h1>
                        <p
                          data-aos="fade-up"
                          data-aos-duration="1500"
                          data-aos-delay="50"
                          className="textTruncate"
                        >
                          {item.des}
                        </p>
                        <Button
                          data-aos="fade-up"
                          data-aos-duration="2000"
                          data-aos-delay="50"
                          className="btn btn-primary btn-white w-40 mt-auto"
                          onClick={() => {
                            trackButtonClick("get_started_cta", { button_name: "Get Started", screen_name: "Home", button_position: "banner" });
                            if (isUserDetails) return;
                            set_login_role();
                          }}
                          to={isUserDetails ? "/dashboard" : `/login`}
                          as={Link}
                        >
                          Get Started
                        </Button>
                      </div>
                    </Col>
                  </Row>
                </Container>
              </section>
            </Carousel.Item>
          ))
        ) : (
          <Carousel.Item>
            <section
              className="bgHome"
              style={{
                backgroundImage: `url(
               ${Loader}
              )`,
              }}
            ></section>
          </Carousel.Item>
        )}
      </Carousel>
    </>
  );
};

export default HomeSlider;
